import React from 'react';
import './FooterView.css';
import { observer } from 'mobx-react';
import { Appl } from '../../core/Appl';
import { Container } from '../../core/components/containers/Container';

type FooterProps = {
  version?: string;
};

export const FooterView: React.FC<FooterProps> = observer(({ version = Appl.Setting.AppVersion }) => {
  return (
    <>
      <div className="bg-cream-50 py-3 md:py-2"><Container>
        <div className='justify-end flex flex-wrap flex-col  md:flex-row items-center text-15px md:divide-x divide-black'>
        <a className='underline hover:underline focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2 rounded-sm px-3' href="https://www.scers.gov/about" target="_blank">About SCERS</a>
        <a className='underline hover:underline focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2 rounded-sm px-3' href="https://my.scers.gov/termsandconditions" target="_blank">Terms and Conditions of Use</a>
        <a className='underline hover:underline focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2 rounded-sm px-3' href="https://www.scers.gov/contact" target="_blank" >Contact Us</a>
        <a className='underline hover:underline focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2 rounded-sm px-3' href="https://www.scers.gov/" target="_blank">scers.gov</a>
        <a className='underline hover:underline focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2 rounded-sm px-3' href="/utility/release-notes" target="_blank">{version}</a>
        </div>
      </Container>
      </div>
    </>
  );
});
